import { render } from "./all-reports.vue?vue&type=template&id=d1082096&scoped=true"
import script from "./all-reports.vue?vue&type=script&lang=js"
export * from "./all-reports.vue?vue&type=script&lang=js"

import "./all-reports.vue?vue&type=style&index=0&id=d1082096&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1082096"]])

export default __exports__